import { CuboidCollider, RigidBody } from '@react-three/rapier';

import { boxGeometry, slateGreyMaterial } from '@utils';

export function Floor({ length = 1, size }) {

    return (
        <RigidBody type="fixed" restitution={0.2} friction={0}>
            <CuboidCollider
                args={[(size / 2), 0.1, length * (size / 2)]}
                position={[0, -0.1, -(length * (size / 2)) + (size / 2)]}
                restitution={0.2}
                friction={1}
            >
                <mesh
                    receiveShadow
                    geometry={boxGeometry}
                    material={slateGreyMaterial}
                    scale={[size, 0.2, length * size]}
                />
            </CuboidCollider>
        </RigidBody>
    )
}